/** Коды ошибок чата → ключи i18n. На коде, а не на тексте, завязан весь UI. */

import { ApiError } from '@shared/api/problem';

export function chatErrorKey(error: unknown): string {
  if (!(error instanceof ApiError)) return 'chat.errors.unexpected';

  switch (error.code) {
    case 'SEARCH_MESSAGE_IN_PROGRESS':
      return 'chat.errors.inProgress';
    case 'SEARCH_SESSION_NOT_FOUND':
      return 'chat.errors.sessionGone';
    case 'CRITERIA_VERSION_MISMATCH':
      return 'chat.errors.versionConflict';
    // Запуск подбора при `readiness_score < 100` (BE-080): арбитр — backend,
    // даже если кнопка на экране выглядела активной.
    case 'CRITERIA_NOT_READY':
      return 'chat.errors.notReady';
    // Гостевой лимит сообщений (BE-205). Отдельный ключ, а не общее «ошибка»:
    // критерии и результаты при этом сохранены, и человеку нужно сказать
    // именно это, а не «что-то пошло не так» (MVP_PRD §41.4).
    case 'GUEST_MESSAGE_LIMIT_REACHED':
      return 'guest.messageLimit.text';
    case 'VALIDATION_ERROR':
      return 'chat.errors.validation';
    case 'NETWORK_ERROR':
      return 'chat.errors.network';
    default:
      break;
  }

  if (error.status === 401) return 'chat.errors.session';
  return 'chat.errors.unexpected';
}

/**
 * Сообщение не дошло до сервера: обрыв сети или таймаут запроса.
 *
 * Текст ошибки обещает «Ihre Eingabe bleibt erhalten», и отправка обязана это
 * обещание держать: набранное возвращается в поле ввода, а не пропадает вместе
 * с откатом оптимистичной реплики (решение заказчика от 22.10.2026).
 */
export function isNetworkError(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'NETWORK_ERROR';
}
